import styled from 'styled-components';
import { Badge } from '@prisjakt/ui/badge';
import { layout, media } from '@prisjakt/ui-base';
import { PriceLabel } from '../price-label';

export const StyledPriceLabel = styled(PriceLabel)`
  font-size: ${layout.measurements.fontSizeXl};
`;

export const StyledSecondaryPrice = styled(PriceLabel)`
  text-decoration: line-through;

  ${media.smallOnly`
    margin-bottom: -${layout.measurements.spacing025};
  `}
`;

export const StyledOfferPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  column-gap: ${layout.measurements.spacing050};
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${layout.measurements.spacing050};
`;

export const StyledMainPrice = styled.div`
  display: flex;
  column-gap: ${layout.measurements.spacing050};

  ${media.mediumUp`
    flex-direction:column;
  `}
`;

export const StyledBadge = styled(Badge)`
  margin-bottom: ${layout.measurements.spacing025};

  > span {
    font-weight: 700;
    font-size: ${layout.measurements.fontSizeSmall};
  }
`;
